<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-12">
                                <div class="pull-left">
                                    <h4 class="card-title float-left" v-if="expert2.id">
                                        {{$t('expert2.titleEAppraisalRealEstateView')}}
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-sm-7">
                                <div role="tablist">
                                    <div class="row">
                                        <div class="col-12">
                                            <div block v-b-toggle.expert2-obj class="all-btn add-btn text-uppercase w-100">
                                                <span style="white-space: normal">Баҳолаш объекти маълумотлари</span>
                                            </div>
                                            <b-collapse id="expert2-obj" accordion="expert2-accordion" visible role="tabpanel" class="mt-3">
                                                <div class="row">
                                                    <div class="col-lg-6">
                                                        <div class="form-group">
                                                            <label>{{$t('expert2.field.owner')}}</label>
                                                            <div class="form-control">
                                                                <div v-if="expert2 && expert2.ownerClient">
                                                                    <strong>{{ expert2.ownerClient.fullName }}</strong>
                                                                    <span> - {{ expert2.ownerClient.firmName }} </span>
                                                                    <span class="badge badge-primary" v-if="expert2.ownerClient.type === 'Legal'"> Юридик шахс</span>
                                                                    <span class="badge badge-primary" v-else> Жисмоний шахс</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label>{{$t('expert2.field.name')}}</label>
                                                            <div class="form-control">
                                                                <span>{{expert2.name}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label>{{$t("expert2.field.evlGoalType")}}</label>
                                                            <div class="form-control">
                                                                <span v-if="expert2.evlGoalType">{{expert2.evlGoalType.typeName}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label>Банк ходими телефон рақами</label>
                                                            <div class="form-control">
                                                                <span>{{expert2.bankPhone}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-6">
                                                        <div class="form-group">
                                                            <label>{{$t("expert2.field.province")}}</label>
                                                            <div class="form-control">
                                                                <span>{{expert2.province.name}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label>{{$t("expert2.field.region")}}</label>
                                                            <div class="form-control">
                                                                <span>{{expert2.region.name}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label>{{$t('expert2.field.address')}}</label>
                                                            <div class="form-control">
                                                                <span>{{expert2.address}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row" v-if="realEstate.id && realEstate.id > 0">
                                                  <div class="col-12">
                                                    <div class="section-header">
                                                      <h4 class="pull-left">
                                                        {{$t("realEstate.field.buildingDocsSubmitted")}}
                                                      </h4>
                                                    </div>
                                                    <div v-for="(building, index) in realEstate.buildings" :key="building.id">
                                                      <div class="section-header">{{ index + 1}} - бино маълумотлари</div>
                                                      <div class="col-md-6">
                                                        <div class="form-group">
                                                          <label>{{$t("building.field.name")}}</label>
                                                          <div class="form-control">{{ building.name }}</div>
                                                        </div>
                                                      </div>
                                                      <PreviewDropZoneEAppraisal
                                                          code="buildingPhotoDropZone"
                                                          label="realEstate.field.docBuildingPhotos"
                                                          :data="building.photos"
                                                          @change="(photos) => {building.photos = photos}"
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                            </b-collapse>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <div block v-b-toggle.expert2-doc class="all-btn add-btn text-uppercase w-100">
                                                <span style="white-space: normal">{{$t('expert2.field.documents')}}</span>
                                            </div>
                                            <b-collapse id="expert2-doc" accordion="expert2-accordion" role="tabpanel" class="scroll">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <div class="section-header">
                                                            <h4>{{$t("expert2.field.docsToSubmit")}}</h4>
                                                        </div>
                                                        <div class="form-group">
                                                            <PreviewDropZone code="cadastreDropZone"
                                                                             label="expert2.field.docCadastre"
                                                                             :data="expert2.cadastre"
                                                                             @change="(files) => {expert2.cadastre = files}"
                                                            />
                                                        </div>
                                                        <div class="form-group">
                                                            <PreviewDropZone code="reportDropZone"
                                                                             label="expert2.field.docReport"
                                                                             :data="expert2.report"
                                                                             @change="(files) => {expert2.report = files}"
                                                            />
                                                        </div>
                                                        <div class="form-group">
                                                            <PreviewDropZone code="buildingDropZone"
                                                                             label="expert2.field.docPhotos"
                                                                             :data="expert2.photos"
                                                                             @change="(files) => {expert2.photos = files}"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-collapse>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-12">
                                        <div :class="{invalid: $v.expert2.buildingType.code.$error}">
                                            <div class="form-group">
                                                <label>{{$t("realEstate.field.buildingType")}} <span class="red">*</span></label>
                                                <v-select v-model="expert2.buildingType" label="name"
                                                          :options="buildingTypes"
                                                          :filterable="false"
                                                          @search:focus="onBuildingFocus"
                                                >
                                                    <template slot="option" slot-scope="option" v-if="option && option.name">
                                                        <div v-html="option.name"></div>
                                                    </template>
                                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                                </v-select>
                                            </div>
                                        </div>
                                        <div class="red" v-if="$v.expert2.buildingType.code.$error">{{$t('newRealEstate.validation.buildingType')}}</div>
                                        <div class="form-group">
                                            <label>{{$t("report.field.agents")}} <span class="red">*</span></label>
                                            <v-select v-model="expert2.agent" label="text"
                                                      :options="agents"
                                                      :filterable="false"
                                                      @search="onUsersSearch"
                                                      @search:focus="onUsersFocus">
                                                <template slot="option" slot-scope="option" v-if="option">
                                                    <div v-html="option.name"></div>
                                                </template>
                                                <template slot="selected-option"
                                                          v-if="expert2.agent && expert2.agent.name">
                                                    <div v-html="expert2.agent.name"
                                                         @click="$eventBus.$emit('search:focus')"></div>
                                                </template>
                                                <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                            </v-select>
                                            <div class="red" v-if="$v.expert2.agent.id.$error">
                                                {{$t("realEstate.field.agent")}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-12">
                                <div class="text-center">
                                    <button class="btn btn-primary"
                                            v-if="canSave && hasPermission('E_BAHOLASH_EXPERT2_REAL_ESTATE_SAVE')"
                                            @click="onSave"
                                            :disabled="processing"
                                    >
                                        <i class="fa fa-save"></i>
                                        {{$t("action.save")}}
                                    </button>
                                    <button class="btn btn-success ml-2"
                                            v-if="isPending && hasPermission('E_BAHOLASH_EXPERT2_REAL_ESTATE_BIND_AGENT')"
                                            @click="onPending"
                                            :disabled="processing"
                                    >
                                        <i class="fa fa-check"></i>
                                        {{$t("expert2.action.pending")}}
                                    </button>
                                    <button class="btn btn-danger ml-2"
                                            v-if="hasPermission('E_BAHOLASH_EXPERT2_REJECT') && canReject"
                                            @click="onReject"
                                    >
                                        <i class="fa fa-reply"></i>
                                        {{$t("expert2.action.reject")}}
                                    </button>
                                    <button class="btn btn-warning ml-2"
                                            v-if="isPending && !isCadastreFixError"
                                            @click="sendFixError"
                                    >
                                      <i class="fa fa-warning"></i>
                                      <span>{{$t("realEstate.plus.sendFixError.title")}}</span>
                                    </button>
                                    <button class="btn btn-default ml-2" @click="cancel" :disabled="processing">
                                        {{$t("action.cancel")}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <expert2-reject-comment />
        <CadastreFixErrorModal :error-msg="$t('realEstate.plus.sendFixError.description')"
                               :request-id="this.expert2.requestId"
                               :evl-object-type="'Expert2'"
                               :requiredIdent="false"
                               @handle-success="handleFixErrorSuccess"
        />
    </div>
</template>

<script>

    import {BCollapse} from 'bootstrap-vue/es/components/collapse/collapse';
    import { VBToggle } from 'bootstrap-vue/es/directives/toggle/toggle'
    import PreviewDropZone from '@/views/real-estate/PreviewDropZone'
    import {required, requiredUnless} from 'vuelidate/lib/validators';
    import initFilterModel from '@/shared/filter';
    import Expert2RejectComment from '@/components/Expert2RejectComment';
    import AdvancedFilter from '@/shared/filters/advancedFilter';
    import PreviewDropZoneEAppraisal from "@/views/real-estate/PreviewDropZoneEAppraisal.vue";
    import CadastreFixErrorModal from "@/components/cadastre/CadastreFixErrorModal.vue";

    export default {
        name: "EExpert2RealEstateView",
        components: {
          CadastreFixErrorModal,
          PreviewDropZoneEAppraisal,
          BCollapse,
          PreviewDropZone,
          Expert2RejectComment
        },
        directives: {
          'b-toggle': VBToggle
        },
        data() {
            return {
                processing: false,
                loading: false,
                filter: initFilterModel(),
                filterBuildingType: new AdvancedFilter(),
                expert2: {
                    id: null,
                    organizationName: '',
                    ownerClient: null,
                    approachCost: false,
                    approachIncome: false,
                    approachComparative: false,
                    name: '',
                    province: {},
                    region: {},
                    address: '',
                    evlGoalType: null,
                    clientReportNumber: '',
                    evlEstimatedDate: null,
                    realEstate: {},
                    cadastre: [],
                    report: [],
                    photos: [],
                    microRegionId: null,
                    cadastreDocNumber: '',
                    isOrganization: false,
                    isReportNumDate: false,
                    isReportDoc: false,
                    isCadDocument: false,
                    isPhotos: false,
                    buildingCount: 0,
                    buildingType: {},
                    agent: {}
                },
                realEstate: {},
                buildingTypes: [],
                agents: []
            }
        },
        validations() {
            return {
                expert2: {
                    buildingType: {
                        code: {
                            required: required
                        }
                    },
                    agent: {
                        id: {
                            required: requiredUnless(() => {
                                return !this.isPending
                            })
                        }
                    }
                }
            }
        },
        computed: {
            isPending() {
                return this.expert2.status === 'Pending';
            },
            isCheckValidation() {
                return this.expert2.isOrganization && this.expert2.isReportNumDate && this.expert2.isReportDoc && this.expert2.isCadDocument && this.expert2.isPhotos;
            },
            canReject() {
                return this.hasPermission('E_BAHOLASH_EXPERT2_REJECT') && this.expert2.status === 'Pending';
            },
            canSave() {
              return this.expert2.status === 'Pending' || this.expert2.status === 'NotFullyEvaluated' || this.expert2.status === 'AssignedToEvaluator';
            },
            isCadastreFixError() {
              return this.realEstate.data && this.realEstate.data.values && (this.realEstate.data.values.getNewCadastre || this.realEstate.data.values.isCadastreError)
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;

                if (id && id > 0) {
                    this.loading = true;

                    this.$http.get(`admin/expert2/${id}`)
                        .then(res => {
                            vm.expert2 = res.data;
                            if (res.data.realEstate) {
                                vm.realEstate = res.data.realEstate;
                            }
                            this.loading = false;
                        }, () => {
                            this.loading = false;
                        })
                }
            },
            onSave() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                this.processing = true;

                this.$http.post('admin/expert2/save', this.expert2)
                    .then(res => {
                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.expert2.statusSuccess'),
                                type: 'success'
                            });
                            this.$router.push('/e-appraisal/expert2/real-estate/list')
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.expert2.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    })
            },
            onPending() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                this.processing = true;

                this.$http.post('admin/e-appraisal/expert2/bind-agent', this.expert2)
                    .then(res => {
                        if (res.data && res.data.code === 'DENIED') {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: this.$t('messages.expert2.validate'),
                                type: 'error'
                            });
                        } else if (res.data && res.data.status === 'SUCCESS') {
                            this.$router.push('/e-appraisal/expert2/real-estate/list')
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.expert2.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    })
            },
            onReject() {
                this.$eventBus.$emit('Expert2RejectComment', this.expert2.id, false, "Expert2", true);
            },
            cancel() {
                this.$router.push('/e-appraisal/expert2/real-estate/list')
            },
            onBuildingFocus() {
                this.buildingTypes = [];
                this.filterBuildingType.onlyParentLookUp = true
                this.$http.post('building-type/list', this.filterBuildingType)
                    .then(res => {
                        if (res.data !== "" && res.data.data.length > 0) {
                            this.buildingTypes = res.data.data;
                        }
                    }, err => {
                        console.log(err);
                    });
            },
            onUsersSearch(searchTxt, loading) {
                loading(true);
                this.agents = [];
                this.filter.search = searchTxt;

                this.filter.province = null;
                this.filter.region = null;

                this.$http.post('user/agent', this.filter)
                    .then(res => {
                        this.agents = res.data.data;
                        loading(false);
                        this.filter.search = '';
                    }, err => {
                        console.log(err);
                        loading(false);
                    });
            },
            onUsersFocus() {
                this.agents = [];
                this.filter.search = '';

                this.filter.province = this.expert2.province ? this.expert2.province : null;
                this.filter.region = null;

                this.$http.post('user/agent', this.filter)
                    .then(res => {
                        this.agents = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            sendFixError() {
              this.$eventBus.$emit('showCadastreFixErrorModal');
            },
            handleFixErrorSuccess() {
              this.cancel()
              this.$eventBus.$emit('eExpert2RealEstateChanged');
            }
        },
        created() {
            this.init();
        }
    }
</script>

<style scoped>
    .btn-expert2 {
        background-color: #87CB16;
        border: 1px solid #87CB16;
        color: #FFFFFF;
        padding: 10px;
        border-radius: 5px;
        margin-bottom: 5px;
        margin-top: 5px;
        cursor: pointer;
        text-align: center;
        line-height: normal;
        position: relative;
        transition: inherit;
        align-items: center;
        text-transform: uppercase;
    }

    .btn-expert2 span {
        color: #fff;
        font-size: 14px;
    }

    .scroll {
        max-height: 600px;
        width: auto;
        overflow: scroll;
    }

    .check-blog .form-check-label {
        text-transform: uppercase;
        font-size: 12px;
    }
</style>